import gql from 'graphql-tag'
import startCase from 'lodash/startCase'

import { AddressFieldsFragment, IAddress } from '../address/address'
import { ISchool, SchoolFieldsFragment } from '../school/school'

export enum InternalRole {
  ECEMentor = 'ece_mentor',
  PartnershipManager = 'partnership_manager',
  PartnershipCoordinator = 'partnership_coordinator',
}

export function displayInternalRole(role: string | null) {
  switch (role) {
    case InternalRole.ECEMentor:
      return 'ECE Mentor'
    case InternalRole.PartnershipManager:
    case InternalRole.PartnershipCoordinator:
      return startCase(role)
    default:
      return null
  }
}

export interface IUser {
  address: IAddress | null
  admin: boolean
  id: number
  email: string
  name: string | null
  internalRole: InternalRole | null
  firstName: string | null
  lastName: string | null
  phone: string | null
  avatarUrl: string
  hasPassword: boolean
  referredBy: string | null
  schoolhouse: ISchool | null
}

export const UserFieldsFragment = gql`
  fragment UserFields on User {
    address {
      ...AddressFields
    }
    admin
    id
    email
    name
    internalRole
    firstName
    lastName
    phone
    avatarUrl
    hasPassword
    referredBy
    preferredLanguage
    schoolhouse {
      ...SchoolFields
    }
  }

  ${AddressFieldsFragment}
  ${SchoolFieldsFragment}
`
